import dayjs from 'dayjs';
import { useDocumentExpiryDate } from './useDocumentExpiryDate';
import { useDocumentExpirationLabel } from 'components/preview/banner/useDocumentExpirationLabel';
import { useTranslation } from 'react-i18next';
import { useContentMetadata } from 'components/editor/hooks/useContentMetadata';
import { ContentType } from 'utils/getContentType';

interface UseExpiredSignatureProps {
  contentId: string;
}

interface UseExpiredSignatureReturn {
  isDisabled: boolean;
  tooltipMessage: string;
}

export const useExpiredSignature = ({ contentId }: UseExpiredSignatureProps): UseExpiredSignatureReturn => {
  const { t } = useTranslation();
  const { getDocumentExpiryDate, isDocumentExpired } = useDocumentExpiryDate({ contentId });
  const { data: documentData } = useContentMetadata(ContentType.DOCUMENT, contentId);

  const currentExpiryAtDate = dayjs(getDocumentExpiryDate.data?.expire_at);
  const { hasExpirationDate } = useDocumentExpirationLabel({ expiryDate: currentExpiryAtDate });
  const isExpired = isDocumentExpired().isExpired === true;
  const isOwner = documentData?.isDocumentBelongsToSameAccount ?? false;

  const isDisabled = hasExpirationDate && isExpired;

  let tooltipMessage = '';
  if (isDisabled) {
    tooltipMessage = isOwner ? t('document.preview.signature.expired_owner') : t('document.preview.signature.expired');
  }

  return { isDisabled, tooltipMessage };
};
